import ObjectFitClass from '../utils/_object-fit'

const $ = jQuery

export default function ObjectFit () {
  new ObjectFitClass()
}